import { ModalV3 } from '@helios/frontend-core';
import { Themes } from '@palmetto/dsm-tokens';

import { SavingsExplainerContent } from './SavingsExplainerContent';

const TRACKING_ID = 'savings-explainer-modal';

export interface SavingsExplainerModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

export const SavingsExplainerModal = ({ isOpen, onDismiss }: SavingsExplainerModalProps) => {
  return (
    <ModalV3 open={isOpen} onClose={onDismiss} trackingId={TRACKING_ID} theme={Themes.core}>
      <SavingsExplainerContent />
    </ModalV3>
  );
};

export default SavingsExplainerModal;
